import { FC, useState, useEffect } from 'react';
import { ProductVM } from '../../../../common/view-model';
import { OverviewState } from '../../overview/model';
import { productInformationState } from '../../productInformation/model';
import { IHowGood, howGoodState } from '../../howGoodScore/model';
import SpinsArrowGreen from '../../../../assets/images/spinsarrowgreen.svg';
import './SubstainabilityComponent.scss';

interface IDistributionComponentProps {
	product: ProductVM | undefined;
	handleShow?: (score: any) => void;
}

export const SubstainabiltyComponent: FC<IDistributionComponentProps> = ({
	product,
	handleShow
}) => {
	const [ingredient, setIngredient] = useState({ ...OverviewState, product });
	const [state, setState] = useState({ ...productInformationState, product });
	const [howgood] = useState<IHowGood>({ ...howGoodState });
	const range = product?.howGoodScore?.source_retail_raiting;
	const score = state.product?.howGoodScore?.score;
	const categoryAverage = product?.howGoodScore?.category_average;
	const invalidScoreName = 'standards not met';

	useEffect(() => {
		setState({ ...productInformationState, product });
	}, [product]);

	useEffect(() => {
		if (!ingredient.product) {
			setIngredient({ ...OverviewState, product });
		}
	}, [product, ingredient]);

	return (
		<div>
			<div
				className={`hg-content ${
					range?.trim().toLowerCase() === invalidScoreName.trim().toLowerCase()
						? 'hg-none-wrapper'
						: ''
				}`}
			>
				<div className='hg-text'>
					<div className='substainability-heading'>
						{'HowGood Sustainability Impact Estimate '}
						<i
							className='ri-question-line question-icon'
							onClick={() => {
								handleShow?.(score);
							}}
						></i>
					</div>
					<div className='substainabiltiy-subheading'>
						<img src={SpinsArrowGreen} className='uparrow' />
						<span className='substainability-subheading-text'>
							This product is in the top {100 - howgood.getPercentage(range!)}% of food products!
						</span>
					</div>
					<div
						className={`estimate-container ${
							range?.trim().toLowerCase() === invalidScoreName.trim().toLowerCase()
								? 'hg-none-estimate-wrapper'
								: ''
						}`}
					>
						<div className='product-estimate'>
							<span className='estimate-text'>{howgood.estimateText}</span>
							<div className='estimate-value-container'>
								<i className='ri-shopping-basket-line'></i>
								<span className='estimate-value'>{score}</span>
							</div>
						</div>
						<span className='versus-text'>{howgood.versusText}</span>
						<div className='category-average'>
							<span className='average-text'>{howgood.categoryAverageText}</span>
							<div className='average-value-container'>
								<i className='ri-organization-chart'></i>
								<span className='average-value'>{categoryAverage}</span>
							</div>
						</div>
					</div>
					<div>
						{range?.trim().toLowerCase() === invalidScoreName.trim().toLowerCase() ? (
							<div className='hg-explanation none-wrapper'>
								<p className='hg-explanation-text'>
									{howgood.getHgText(howgood.getPercentage(range!))}
								</p>
							</div>
						) : (
							<div className='hg-explanation'>
								<p className='hg-explanation-text'>
									{howgood.hgPrevText}
									<b>{howgood.getHgText(howgood.getPercentage(range!))} </b>
									{howgood.hgNextText}
								</p>
							</div>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
